module.exports = __webpack_public_path__ + "static/todo-9134975db6ed5af6dce9a305984bc263.png";